"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionSubheading = exports.tasksContent = exports.buttonText = exports.tasksStateCount = void 0;
const React = __importStar(require("react"));
const tasks_1 = require("../../../tasks");
const types_1 = require("../../../entities/fact/types");
const accordion_1 = require("../../components/accordion");
const IconTextSpan_1 = require("../../components/icon-text-span/IconTextSpan");
const TaskColumns_1 = require("./TaskColumns");
const Task_1 = require("../../components/task/Task");
const constants_1 = require("../../../tasks/constants");
const details_1 = require("../../../tasks/details");
const RoutingContext_1 = require("../../../context/RoutingContext");
const useCopyContext_1 = __importDefault(require("../../../hooks/useCopyContext"));
const helpers_1 = require("./helpers");
const ValidationContext_1 = require("../../../context/ValidationContext");
const tasksStateCount = (tasks, capabilities, property) => {
    const actualTasks = (0, helpers_1.overlayTaskCompletionState)(tasks, capabilities, property);
    let complete = 0;
    let incomplete = 0;
    Object.keys(actualTasks).forEach((t) => {
        const state = actualTasks[t];
        if (state.completion === types_1.TaskCompletionState.COMPLETE) {
            complete++;
        }
        else if (![
            types_1.TaskCompletionState.DISABLED,
            types_1.TaskCompletionState.HIDDEN,
        ].includes(state.completion)) {
            incomplete++;
        }
    });
    return { complete, incomplete };
};
exports.tasksStateCount = tasksStateCount;
const buttonText = (taskCompletion, readOnly) => {
    if (readOnly) {
        return 'View';
    }
    else {
        if ([
            types_1.TaskCompletionState.INPUT_REQUIRED,
            types_1.TaskCompletionState.REVIEW_REQUIRED,
        ].includes(taskCompletion)) {
            return 'Review';
        }
        else {
            return 'Edit';
        }
    }
};
exports.buttonText = buttonText;
const tasksContent = (tasks, property, customer, capabilities, nameOverrides, pricing) => {
    const { baseUrl } = React.useContext(RoutingContext_1.RouterContext);
    const { state: validation } = React.useContext(ValidationContext_1.ValidationContext);
    return Object.keys(tasks).map((t, idx) => {
        var _a;
        const taskState = tasks[t];
        const overlay = tasks_1.TaskDetails[t].overlay
            ? tasks_1.TaskDetails[t].overlay(capabilities, property, pricing)
            : {};
        const taskDetailsSummary = details_1.TaskDetailsFactory[t](property, customer, overlay.completion || taskState.completion, capabilities, validation);
        const title = (_a = nameOverrides === null || nameOverrides === void 0 ? void 0 : nameOverrides[t]) !== null && _a !== void 0 ? _a : constants_1.TASK_NAMES[t];
        return (React.createElement(Task_1.Task, { key: `task-${title}`, title: title, buttonText: overlay.noReadOrEdit
                ? undefined
                : (0, exports.buttonText)(overlay.completion || taskState.completion, overlay.readOnly || tasks_1.TaskDetails[t].readOnly), completion: overlay.completion || taskState.completion, link: overlay.noReadOrEdit
                ? undefined
                : `${baseUrl}/tasks/${tasks_1.TaskDetails[t].routeName}` }, taskDetailsSummary ? taskDetailsSummary : null));
    });
};
exports.tasksContent = tasksContent;
const sectionSubheading = (complete, incomplete) => {
    const total = complete + incomplete;
    return `${complete} of ${total} sections complete.`;
};
exports.sectionSubheading = sectionSubheading;
exports.default = (props) => {
    const copyContext = (0, useCopyContext_1.default)();
    const { section, tasks, property, customer, capabilities, taskNameOverrides, pricing, } = props;
    const lhTasks = {};
    const rhTasks = {};
    const visibleTasks = (0, helpers_1.fromEntries)(Object.entries(tasks).filter(([_, state]) => (state === null || state === void 0 ? void 0 : state.completion) !== types_1.TaskCompletionState.HIDDEN));
    Object.keys(visibleTasks).forEach((t, idx) => {
        if ((idx + 1) % 2 === 0) {
            rhTasks[t] = tasks[t];
        }
        else {
            lhTasks[t] = tasks[t];
        }
    });
    const { incomplete: incompleteCount, complete: completeCount } = (0, exports.tasksStateCount)(tasks, capabilities, property);
    return (React.createElement(accordion_1.Accordion, { "data-testid": `task-section-${section}`, persistenceId: `tn-task-section-${section}` },
        React.createElement(accordion_1.AccordionHeader, null,
            React.createElement(accordion_1.DefaultAccordionHeading, { heading: (0, tasks_1.TASK_SECTION_NAMES)(copyContext)[section], subheading: React.createElement(IconTextSpan_1.IconTextSpan, { icon: incompleteCount > 0 ? 'exclamation' : 'check', display: incompleteCount > 0 ? 'error' : 'success', iconSize: "large", text: (0, exports.sectionSubheading)(completeCount, incompleteCount) }) })),
        React.createElement(accordion_1.AccordionItem, { noBorder: true },
            React.createElement(TaskColumns_1.TaskFlexWrapper, null,
                React.createElement(TaskColumns_1.TaskColumnWrapper, null, (0, exports.tasksContent)(lhTasks, property, customer, capabilities, taskNameOverrides, pricing)),
                React.createElement(TaskColumns_1.TaskColumnWrapper, null, (0, exports.tasksContent)(rhTasks, property, customer, capabilities, taskNameOverrides, pricing))))));
};
//# sourceMappingURL=TaskSection.js.map